import { ExtraCostCsvParseResult } from '../models/extra-cost.model';

const NEW_LINE_REGEX = /\r\n|\n/;
const NEW_LINE_AT_END_OF_INPUT = /[\r|\n]+$/;
const FIELD_DELIMITER = ';';

export function parse(csv: string): ExtraCostCsvParseResult {
  const rows = csv
    // remove trailing EOL if any
    .replace(NEW_LINE_AT_END_OF_INPUT, '')
    .split(NEW_LINE_REGEX)
    .slice(1) // Note: To not process headers row
    .map((row) => {
      const [productId, , infoPage] = row.split(FIELD_DELIMITER);
      return [productId, infoPage];
    });

  if (rows.length === 0) {
    return { rows: null, hasError: true };
  }
  return { rows, hasError: false };
}
